import { DEFAULT_ACCENT } from "../theme";
import { supabase } from "../supabase";

export interface EventCategory {
  id: string;
  name: string;
  color: string;
}

/** 前後の空白を落とし、空なら無効とみなす */
export function normalizeCategoryName(raw: string): string | null {
  const name = raw.trim();
  return name === "" ? null : name;
}

interface EventCategoryRow {
  id: string;
  name: string;
  color?: string | null;
}

/** color 列がまだ無い環境(マイグレーション適用前)でも既定色にフォールバックする */
function colorOf(row: EventCategoryRow): string {
  return typeof row.color === "string" && /^#[0-9a-fA-F]{6}$/.test(row.color)
    ? row.color
    : DEFAULT_ACCENT;
}

export async function fetchEventCategories(): Promise<EventCategory[]> {
  // color 列がまだ無い環境でも一覧が壊れないよう、列を名指しせずに取る(→ lib/media/tags.ts と同じ考え方)
  const { data, error } = await supabase.from("event_categories").select("*").order("name");
  if (error) throw error;
  const rows = data as EventCategoryRow[];
  return rows.map((row) => ({ id: row.id, name: row.name, color: colorOf(row) }));
}

/**
 * カテゴリを作る。既にあれば作らずにそれを返す。
 * couple_id は DB 側の既定値で埋まる(→ 20260813140000_event_categories.sql)。
 */
export async function createEventCategory(name: string, color: string): Promise<EventCategory> {
  const { data, error } = await supabase
    .from("event_categories")
    .upsert({ name, color }, { onConflict: "couple_id,name" })
    .select("id, name, color")
    .single();
  if (error) throw error;
  const row = data as EventCategoryRow;
  return { id: row.id, name: row.name, color: colorOf(row) };
}
